export const DISABLED_UPHOLSTERY = [];
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});

export const SUNBRELLA_NAME_MISMATCH_OPTIONS = {
  'Sunbrella Premier Fog': 'Premier Fog',
  'Sunbrella Premier Indigo': 'Premier Indigo',
  'Sunbrella Premier Wisteria': 'Premier Wisteria',
  'Sunbrella Premier Lagoon': 'Premier Lagoon',
  'Sunbrella Premier Sea': 'Premier Sea',
};

export const CYLINDO_FRAMES_TO_SHOW = [1, 5, 9, 13, 17];
export const CYLINDO_CONTENT_API = 'https://content.cylindo.com/api/v2';
